
export default {
	orderList: state => state.orderIds.map(id => state.orders[id]),
}